import React from 'react'
import "./style.scss"

import MedalLink from '../MedalsEbit-Link'

import StepImg1 from '../../assets/imagens/ic_csd_st_1.png'
import StepImg2 from '../../assets/imagens/ic_csd_st_2.png'
import StepImg3 from '../../assets/imagens/ic_csd_st_3.png'
import StepImg4 from '../../assets/imagens/ic_csd_st_4.png'



const StepSurvey = () => {
  return (
    <>
      <div className="stepSurvey container-fluid">
        <div className="container aboutUs">
          <h3>Processo de Pesquisa</h3>
          <p>
          A Ebit | Nielsen está presente desde o momento da decisão da compra online, na qual o consumidor pode pesquisar as lojas virtuais de acordo com suas medalhas (Bronze, Prata, Ouro e Diamante), definidas 100% pela a opinião dos próprios consumidores, por meio de pesquisa online que avalia a experiência de compra em dois momentos: após a compra no site e após o recebimento do produto.
        </p>
        </div>

        <div className="items-stepSurvey">
          <div className="items-stepSurvey__box-stepSurvey">
            <div className="img-stepSurvey">
              <img src={StepImg1} alt="Pesquisa passo 1" />
            </div>
            <h6>Decisão de compra</h6>
            <p>Consumidor procura por uma loja confiável para comprar online o produto desejado. Encontra uma que tenha medalha Ebit|Nielsen, clica na medalha para ver se é real e, ao confirmar, decide comprar.</p>
          </div>

          <div className="items-stepSurvey__box-stepSurvey">
            <div className="img-stepSurvey">
              <img src={StepImg2} alt="Pesquisa passo 2" />
            </div>

            <h6>Experiência de compra</h6>
            <p>Após a compra online em uma loja conveniada à Ebit|Nielsen, o consumidor visualiza o banner da Ebit|Nielsen na tela de confirmação de compra, que o levará à primeira pesquisa sobre sua experiência.</p>
          </div>

          <div className="items-stepSurvey__box-stepSurvey">
            <div className="img-stepSurvey">
              <img src={StepImg3} alt="Pesquisa passo 3"/>
            </div>
            <h6>Pesquisa de Satisfação de Compra</h6>
            <p>Os consumidores avaliam a loja virtual em quesitos sobre sua experiência de compra e demais informações como frete, meios de pagamento e entrega no prazo.</p>
          </div>

          <div className="items-stepSurvey__box-stepSurvey">
            <div className="img-stepSurvey img-stepSurvey01">
              <img src={StepImg4} alt="Pesquisa passo 4" />
            </div>
            <h6>Pesquisa de Pós-Venda</h6>
            <p>Após o prazo de entrega informado, a Ebit|Nielsen envia a segunda pesquisa via e-mail para avaliar a experiência pós-venda da loja.</p>
          </div>
        </div>
      </div>
    </>
  )
}

export default StepSurvey